// 引入 superagent
const request = require('superagent')
import baseUrl  from '@/config/env'
function apiBase(obj) {
  let r = request(obj.type, obj.url).accept(obj.dataType).set("Access-Control-Allow-Origin", "*").withCredentials()

  if (obj.uploadfile) {
    r.field('mediaCategory', "CST")
    r.attach('mediaFile', obj.data)
  } else {
    r.type(obj.contentType)
  }

  //设置超时时间
  let timeout = obj.timeout || 15000
  r.timeout({ deadline: timeout })

  if (obj.type === 'post' && !obj.uploadfile) {
    let data = obj.uploadfile ? obj.data : obj.data
    r = r.send(data)
  } else if (obj.type === 'get') {
    r = r.query(obj.data)
  }

  r.end(function (err, res) {
    if (err) {
      if (err.timeout) {
        obj.error('请求超时! ')
      } else {
        obj.error(err)
      }
      return
    }
    let body = res.body;
    if(!body && res.text){
      body = JSON.parse(res.text);
    }
    obj.success(body);
  })
}

const Ajax = (params) => {
  // 请求接口，加载loading
  let loading = String(params.loading) == "undefined" ? true : params.loading;
  let loadingToast = false;
  if (loading && window.Toast) {
    loadingToast = Toast.loading({
      duration: 0,
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner'
    });
  }

  let defaults = {}
  let urlstr = baseUrl + params.url
  if (params.uploadfile) { // 文件类型
    defaults = {
      url: urlstr,
      type: params.type ? params.type : "post",
      dataType: params.dataType ? params.dataType : "form-data",
      contentType: params.contentType ? params.contentType : "application/x-www-form-urlencoded"
    }
  } else { // 正常post、get接口
    defaults = {
      url: urlstr,
      dataType: params.dataType ? params.dataType : "json",
      contentType: params.contentType ? params.contentType : "application/x-www-form-urlencoded",
      type: params.type ? params.type : "post",
      async: String(params.async) ? params.async : true,
    }
    // if (params.type === "post") {
    //   // params.data = JSON.stringify(params.data)
    //   defaults.dataType = "json"
    //   defaults.contentType = "application/x-www-form-urlencoded"
    // }
  }

  for (let key in defaults) {
    params[key] = defaults[key]
  }
  const _successFn = params.success
  const _error = params.error
  params.beforeSend = function (req) { } // 接口调用之前发送请求

  //发送成功
  params.success = function (result, status, xhr) {
    if (loading && window.Toast) { // 接口请求成功，关闭loading
      loadingToast.clear();
    }
    if (result && result.errno === 0) { // 请求成功，返回数据
      _successFn(result, status, xhr)
    } else { // 请求成功，返回错误信息
      if (_error) {
        _error(result);
      } else {
        Toast(result?result.errmsg:"网络错误");
      }
    }
  }
  params.error = function (err) { // 请求失败
    if (loading && window.Toast) {
      loadingToast.clear();
    }
    if(window.Toast){
      Toast(err);
    }
  }
  apiBase(params)
}


export default Ajax


// WEBPACK FOOTER //
// ./src/util/ajax.js